// extracted by mini-css-extract-plugin
export default {"catSelect":"CategorySelector_catSelect__j7ALy"};